export default __webpack_public_path__ + "static/media/information--go-straight-or-right--g1.74189079.png";